import {useCallback, useState} from 'react';
import {Add, Close, Done, Edit} from '@mui/icons-material';
import {IconButton, Stack, TextField, Typography} from '@mui/material';
import SubmitButton from '../../styles/buttons/SubmitButton';

const NameUpdateAliasShow = ({
  name,
  url,
  onSuccess,
  payloadKey,
  isEditAllowed,
}: {
  name: string;
  url: string;
  onSuccess: (val: string) => void;
  payloadKey: string;
  isEditAllowed: boolean;
}) => {
  const [label, setLabel] = useState(name);
  const [isEdit, setIsEdit] = useState(false);

  const handleEdit = useCallback(() => {
    setLabel(name);
    setIsEdit(true);
  }, [name]);

  const handleClose = useCallback(() => {
    setLabel(name);
    setIsEdit(false);
  }, [name]);

  const successAction = useCallback(() => {
    onSuccess(label);
    handleClose();
  }, [handleClose, label, onSuccess]);

  if (isEdit) {
    return (
      <Stack direction='row' alignItems='center' className='w-full' spacing={1}>
        <TextField
          value={label}
          onChange={e => setLabel(e.target.value)}
          fullWidth
        />
        <SubmitButton
          url={url}
          payload={{[payloadKey]: label}}
          title='Submit'
          icon={<Done />}
          buttonProps={{disabled: !label, color: 'success'}}
          successAction={successAction}
        />
        <IconButton onClick={handleClose} title='Cancel' color='error'>
          <Close />
        </IconButton>
      </Stack>
    );
  }
  return (
    <Stack
      direction='row'
      alignItems='center'
      spacing={2}
      className='w-full'
      maxWidth={400}>
      <Typography
        title={name}
        noWrap
        style={{flex: 1, overflow: 'hidden', textOverflow: 'ellipsis'}}>
        {name}
      </Typography>
      {isEditAllowed && (
        <IconButton onClick={handleEdit}>
          {name ? <Edit /> : <Add />}
        </IconButton>
      )}
    </Stack>
  );
};

export default NameUpdateAliasShow;
